import { render, staticRenderFns } from "./advertisementManager.vue?vue&type=template&id=10bf018d"
import script from "./advertisementManager.vue?vue&type=script&lang=js"
export * from "./advertisementManager.vue?vue&type=script&lang=js"
import style0 from "./advertisementManager.vue?vue&type=style&index=0&id=10bf018d&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports